export default "__VITE_ASSET__BYxFc9SN__"